import React, { useEffect, useState } from 'react'
import Loader from '../../components/Loader'
import { Link } from 'react-router-dom'
import { formatDate } from '../../utils/helpers';
import axiosInstance from '../../utils/api';

type Props = {}
interface SomPassedInterface {
    id: number;
    datetime: string;
    pcba_name: string;
    mcuid: string;
    version: string;
}

const SomPassed = (props: Props) => {
    const title = "Som Passed"
    const [loading, setLoading] = useState(false)
    const [somPassed, setSomPassed] = useState<any>([])
    const [testDetailModal, setTestDetailModal] = useState(false)
    const [selectedTestDetail, setSelectedTestDetail] = useState({
        title: "",
        content: ""
    })

    useEffect(() => {
        getData()
    }, [])

    function getData() {
        setLoading(true)
        axiosInstance.get("https://api.cl-ds.com/internal/operations/v1.0/pcba/som").then(res=>{
            setLoading(false)
            console.log(11, res.data)
            setSomPassed(res.data)
        }).catch(err=>{
            setLoading(false)
            console.log(123, err)
        })
    }

    function handleDelete(id:string) {
        if (!window.confirm("Are you sure you want to delete record?")) return
        // setLoading(true)
        // axiosInstance.delete(`https://api.cl-ds.com/internal/operations/v1/pcba/${id}/`).then(res=>{
        //     setLoading(false)
        //     console.log(11, res)
        //     alert(res.data.message)
        //     getDateList()
        // }).catch(err=>{
        //     setLoading(false)
        //     console.log(123, err)
        // })
    }
    return (
                
        <div className="col-12">
            {loading && ( <Loader/> )}

            <div className="card">
                <div className="card-body">
                    <div className="row px-2" style={{display:"grid", gridTemplateColumns:"1fr 1fr"}}>
                        <h5 className="card-title">{title} List</h5>
                        <div style={{display:"flex", justifyContent:"end", alignSelf:"center"}}>
                            
                            <Link to="/pcba/add" >
                                <button type="button" className="btn btn-outline-info">Create</button>
                            </Link>
                        </div>

                    </div>

                    <div className="table-responsive">
                        <table className="table table-striped">
                            <thead>
                                <tr>
                                    <th scope="col">Datetime</th>
                                    <th scope="col">Pcba Name</th>
                                    <th scope="col">Pcba Version</th>
                                    <th scope="col">MCUID</th>
                                    <th scope="col">Firmware 1 Name</th>
                                    <th scope="col">Firmware 1 Version</th>
                                    <th scope="col">Firmware 2 Name</th>
                                    <th scope="col">Firmware 2 Version</th>
                                    <th scope="col">Is Used</th>
                                    <th scope="col">Test Detail</th>
                                </tr>
                            </thead>
                            <tbody>
                                {somPassed.map( (som:any, index:number) => {
                                    return (
                                        <tr key={index}>
                                            <th scope="row">{formatDate(som.datetime)}</th>
                                            <td>{som.package.name.name}</td>
                                            <td>{som.package.version}</td>
                                            <td>{som.mcuid}</td>
                                            <td>{som.package.upload_order_1.name}</td>
                                            <td>{som.package.upload_order_1.version}</td>
                                            <td>{som.package.upload_order_2 && som.package.upload_order_2.name}</td>
                                            <td>{som.package.upload_order_2 && som.package.upload_order_2.version}</td>
                                            <td>{som.is_used}</td>
                                            {som.test_details ? (
                                            <td>
                                            <button type="button" className="btn btn-outline-info" onClick={()=>{
                                                setSelectedTestDetail({
                                                    title: som.package.name.name,
                                                    content: som.test_details
                                                })
                                                setTestDetailModal(true)
                                            }}>Show</button>
                                            </td>
                                            ) : (
                                                <td></td>
                                            )}
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>

                </div>
            </div>

            <div className="modal fade show" style={testDetailModal ? {display:'block'} : {display: 'none'}}>
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLongTitle">{selectedTestDetail.title}</h5>
                    </div>
                    <div className="modal-body">
                        { selectedTestDetail.content}
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={()=>{setTestDetailModal(false)}}>Close</button>
                    </div>
                    </div>
                </div>
            </div>

        </div>

    )
}

export default SomPassed